<template>
  <Modal width="920" title="提交结果" class-name="vertical-center-modal" v-model="state" :mask-closable="false">
    <Spin size="large" fix v-if="show"></Spin>
    <div class="c-success-warpper">
      <div class="c-success-header"><h3>计划组创建结果</h3></div>
      <Table height="300" :columns="success_h" :data="data"></Table>
    </div>

    <div slot="footer" class="c-convert-footer">
      <div>
        <Button type="default" v-if="btnRetry" @click="$emit('on-retry')">重试</Button>
        <Button type="default" @click="close">完成并关闭</Button>
        <Button type="primary" v-if="btnSuccess" @click="jump">批量新建计划</Button>
      </div>
    </div>
  </Modal>
</template>
<script>
import mixin from './mixin'
export default {
  name: 'resultGroup',
  mixins: [mixin],
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    },
    show: {
      type: Boolean
    },
    next: {
      type: String,
      default: 'toutiaoplan'
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    btnSuccess() {
      return this.data.some((ret) => !ret.status)
    },
    btnRetry() {
      return this.data.some((ret) => ret.status)
    }
  },
  methods: {
    close() {
      this.closePageForm()
    },
    jump() {
      const ids = []
      this.data.forEach((ret) => {
        if (ret) {
          ids.push(parseInt(ret.id))
        }
      })
      if (ids.length) {
        window.sessionStorage.setItem('campaigns', JSON.stringify(ids))
        this.$router.push({
          name: this.next,
          params: {
            id: ids[0]
          }
        })
      } else {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: '创建计划组全部失败，不能创建计划'
        })
      }
    }
  },
  data() {
    return {
      // 表格表头
      success_h: [
        {
          key: 'media_name',
          title: '媒体'
        },
        {
          key: 'name',
          title: '计划组名称'
        },
        {
          key: 'msg',
          title: '计划组建立结果'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.c-success-warpper {
  padding: 0 20px 12px 20px;

  .c-success-header {
    text-align: center;
    padding: 12px 0;
  }
}
</style>
